<template>
  <base-modal modal-id="top-up">
    <template v-slot:header>
      <h4 class="modal-title mb-0">
        {{ _T('Top-up') + ' ' }}
        {{ domainBasedBrand ? _T_DB(currentBrand, 'name') : _T('Go Order') }}
      </h4>
    </template>
    <template v-slot:modal-body>
      <form class="default-form">
        <div class="form-group">
          <label>{{ _T('Amount') }}</label>
          <div class="select-value-box">
            <span class="light-bg">{{ _T('AED') }}</span>
            <span class="select-value">{{ _T('150') }}</span>
          </div>
          <div class="desired-time">
            <div class="box-checkbox">
              <ul class="row">
                <li class="col-sm-4">
                  <label for="chk-ani14">
                    <input
                      class="radio_animated"
                      id="chk-ani14"
                      type="radio"
                      name="rdo-ani2"
                    />
                    <span>{{ _T('AED 50') }}</span>
                  </label>
                </li>
                <li class="col-sm-4">
                  <label for="chk-ani15">
                    <input
                      class="radio_animated"
                      id="chk-ani15"
                      type="radio"
                      name="rdo-ani2"
                      checked=""
                    />
                    <span>{{ _T('AED 100') }}</span>
                  </label>
                </li>
                <li class="col-sm-4">
                  <label for="chk-ani16">
                    <input
                      class="radio_animated"
                      id="chk-ani16"
                      type="radio"
                      name="rdo-ani2"
                    />
                    <span>{{ _T('AED 150') }}</span>
                  </label>
                </li>
                <li class="col-sm-4">
                  <label for="chk-ani17">
                    <input
                      class="radio_animated"
                      id="chk-ani17"
                      type="radio"
                      name="rdo-ani2"
                    />
                    <span>{{ _T('AED 200') }}</span>
                  </label>
                </li>
                <li class="col-sm-4">
                  <label for="chk-ani18">
                    <input
                      class="radio_animated"
                      id="chk-ani18"
                      type="radio"
                      name="rdo-ani2"
                    />
                    <span>{{ _T('AED 250') }}</span>
                  </label>
                </li>
                <li class="col-sm-4">
                  <label for="chk-ani19">
                    <input
                      class="radio_animated"
                      id="chk-ani19"
                      type="radio"
                      name="rdo-ani2"
                    />
                    <span>{{ _T('AED 300') }}</span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-solid btn-block"
          data-toggle="modal"
          data-dismiss="modal"
          @click="proceedForward"
        >
          {{ _T('Next') }}
        </button>
      </form>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '../BaseModal'
import { mapGetters } from 'vuex'
export default {
  name: 'TopUp',
  components: {
    BaseModal,
  },
  computed: {
    ...mapGetters(['_T', 'domainBasedBrand', '_T_DB', 'currentBrand']),
  },
  methods: {
    proceedForward() {
      this.$bvModal.hide('top-up')
      this.$bvModal.show('top-up-payment')
    },
  },
}
</script>

<style lang="scss" scoped>
.default-form {
  .form-group {
    label {
      font-weight: 600;
      font-size: $px14;
      line-height: $px22;
      letter-spacing: 0.5px;
      color: $light-font;
      margin-bottom: $px12;
    }

    .select-value-box {
      width: 100%;
      border: $px2 solid $light-border;
      border-radius: $px4;

      span {
        padding: $px12 $px14;
        display: inline-block;
        font-weight: 600;
        font-size: $px16;
        line-height: $px19;
        letter-spacing: 0.02em;

        + span {
          margin-left: -$px4;
        }
      }

      .light-bg {
        background-color: $light-border;
        color: rgba(var(--color-font-color-source), 0.8);
      }
    }
  }
}

.desired-time {
  margin-top: calc(#{$px20} + (50 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
  .box-checkbox {
    ul {
      margin: 0;
      li {
        padding: 0;

        &:nth-child(4) {
          padding-left: 0;
        }

        + li {
          padding-left: $px15;

          + li {
            + li {
              label {
                margin-bottom: 0;
              }
            }
          }
        }
        label {
          margin-bottom: 0;
          width: 100%;
          position: relative;
          cursor: pointer;
          .radio_animated {
            float: right;
            margin-right: $px6;
            margin-top: $px5;
            opacity: 0;
            &:after {
              border-radius: $px2;
              background-color: $white;
              border: none;
            }
            &:before {
              transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
              transform: rotate(-45deg) scale(0, 0);
              left: $px3;
              top: $px1;
              z-index: 1;
              width: 0.75rem;
              height: 0.375rem;
              border: $px2 solid $white;
              border-top-style: none;
              border-right-style: none;
              background: $transparent;
              border-radius: 0;
            }
            &:checked {
              opacity: 1;
              &:after {
                background-color: $color-primary;
              }
              &:before {
                transform: rotate(-45deg) scale(1, 1);
              }
              ~ span {
                border: $px2 solid $color-primary;
                transition: all 0.5s ease;
                color: $color-primary;
              }
            }
          }
          span {
            padding: calc(
              #{$px8} + (15 - 8) * ((100vw - #{$px320}) / (1920 - 320))
            );
            border: $px2 solid $light-border;
            display: block;
            border-radius: $px4;
            transition: all 0.5s ease;
            font-weight: 600;
            font-size: calc(
              #{$px14} + (16 - 14) * ((100vw - #{$px320}) / (1920 - 320))
            );
            line-height: $px19;
            text-align: center;
            letter-spacing: 0.02em;
          }
        }
        &.col-sm-6 {
          &:nth-child(odd) {
            padding: 0;
          }
          &:nth-child(even) {
            padding-right: 0;
          }
        }
      }
    }
    .timing-checkbox {
      padding-top: calc(
        #{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );
      margin-top: calc(
        #{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );
      border-top: $px1 solid $light-border;
      height: $px346;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      li {
        label {
          span {
            border: $px2 solid $light-font;
            background: $light-font;
          }
          .radio_animated {
            &:after {
              background: $light-font;
            }
            &:checked {
              ~ span {
                background-color: $white;
              }
            }
            &:disabled {
              ~ span {
                color: rgba(var(--color-font-color-source), 0.3);
              }
            }
          }
        }
        + li {
          + li {
            margin-top: $px15;
          }
        }
      }
    }
  }
  h4 {
    margin-bottom: calc(
      #{$px8} + (10 - 8) * ((100vw - #{$px320}) / (1920 - 320))
    ) !important;
  }
}
</style>
